/** @format */

import {Navigate, useLocation} from 'react-router-dom';

export const RedirectTo = ({to}: {to: string}) => {
  const location = useLocation();
  return <Navigate to={to} replace state={location.state} />;
};
